import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.tsx';
import {
	CenterContainer,
	Container,
	InnerContainer,
	LeftContainer,
	RightContainer,
} from './styled';
import {
	Header,
	SubHeader,
} from '@dealstack/frontend/shared/components/Documents/UploadDocuments/styled';
import { constructTransactionSentence } from '@dealstack/frontend/shared/utils/constructTransactionSentence';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { CurrencyType, SecurityIssuedIn, TransactionType } from '@dealstack/shared/lib/generated';

interface Props {
	transactionId: string;
	issuerName: string;
	transactionType?: TransactionType;
	units?: number;
	price?: number;
	securityName: string;
	buyerName?: string;
	sellerName?: string;
	transactionDate: string;
	disabled?: boolean;
	/** Which kind of entity an already-uploaded document is linked to, if any. */
	linkedTo?: 'person' | 'transaction';
	checked: boolean;
	onClick?: () => void;
	securityIssuedIn?: SecurityIssuedIn;
	securityCurrency?: CurrencyType;
	securityUnitDenominator: number;
}

export const TransactionInformationItem = ({
	issuerName,
	securityName,
	transactionDate,
	transactionType,
	units,
	buyerName,
	sellerName,
	price,
	disabled = false,
	checked = false,
	linkedTo,
	onClick,
	securityIssuedIn,
	securityCurrency,
	securityUnitDenominator,
}: Props) => {
	const tCapManage = useTranslationCapManage();
	const subHeading = () => {
		if (linkedTo === 'person') {
			return `Uploaded to ${issuerName}`;
		}

		// it will be a transaction
		if (transactionType && securityName) {
			return constructTransactionSentence({
				transactionType,
				units: units ?? 0,
				securityName,
				transactionDate,
				sellerName,
				buyerName,
				cost: price ?? 0,
				securityIssuedIn,
				securityCurrency,
				securityUnitDenominator,
			});
		}

		if (!linkedTo) {
			return tCapManage('manage_file_association.no_links');
		}
	};

	return (
		<Container>
			<InnerContainer $disabled={disabled} onClick={onClick}>
				<LeftContainer>
					<Icon
						size="1.25rem"
						variant={linkedTo === 'person' ? 'user-profile' : 'money-v3'}
					/>
				</LeftContainer>
				<CenterContainer>
					<Header>{issuerName}</Header>
					<SubHeader>{subHeading()}</SubHeader>
				</CenterContainer>
				<RightContainer $opacity={disabled ? 0.32 : 1}>
					<Icon
						variant={checked ? 'link-chain-blue' : 'checkbox-unchecked'}
						size="1.25rem"
					/>
				</RightContainer>
			</InnerContainer>
		</Container>
	);
};
